<template>
<main class="content-body">
  <header class="page-header">
    <h2>Zone A</h2>
  </header>
  <div class="row">
    <div class="col-md-12 col-lg-12 col-xl-12">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title" style="display:inline; color:#808080;">{{ticket.type}} - #{{ticket.ticket_id}}</h2>
              <div style="float:right;display:inline">
                  <router-link :to="{name:'billet_creation'}" class="btn btn-primary"><i class="fa fa-plus"></i> Créer un billet</router-link>
              </div>
            </header>
            <div class="panel-body">
              <div class="row" style='margin-top:5px'>

                <div class="col-sm-9">

                  <div class="row">
                    <div class="col-sm-12">

                      <div class="form-group">
                        <strong class="control-label">Titre</strong>
                        <br>
                        <div class="za_editbox" v-show="readmode.title" v-on:click="editMode('title')">
                          <em v-if="!ticket.title" class="text-muted">Entrer un titre...</em>
                          <div v-text="ticket.title"></div>
                        </div>
                        <span v-show="!readmode.title">
                          <input class="form-control" v-model="ticket.title">
                          <label class="error" v-if="errors.title">{{ errors.title }}</label>
                          <div style="margin-top:5px">
                            <button type="button" class="btn btn-primary btn-sm" v-on:click="save()"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
                            <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('title')">Annuler</button>
                          </div>
                        </span>
                      </div>

                      <div v-if="ticket.service_provider_id" class="form-group">
                        <div class="za-label">Fournisseur</div>
                        <div>
                          <router-link :to="{ name: 'sp_tableaudebord', params: { service_provider_id: ticket.service_provider_id }}"
                            v-text="ticket.service_provider"></router-link>
                        </div>
                      </div>

                      <div v-if="ticket.requirement_id" class="form-group">
                        <div class="za-label">Exigence</div>
                        <div>
                          <router-link :to="{ name: 'exigenceDetail', params: { service_provider_id: ticket.service_provider_id, requirement_num: ticket.requirement_master_num}}">
                            {{ticket.requirement_master_num}} {{ticket.requirement_master_name}}
                          </router-link>
                        </div>
                      </div>

                      <div v-if="ticket.designation_dossier_id" class="form-group">
                        <div class="za-label">Dossier de désignation</div>
                        <div>
                          <router-link :to="{ name: 'dossier', params: { service_provider_id: ticket.service_provider_id, designation_dossier_id: ticket.designation_dossier_id}}">
                            {{ticket.designation_dossier_name}}
                          </router-link>
                        </div>
                      </div>

                      <div v-if="effectiveAt !== null" class="form-group">
                        <div class="row"><div class="col-sm-3">
                        <div class="za-label">Effectif</div>
                        <datepicker :format="format" :language="fr" :value="effectiveAt" @input="effectiveAt = $event; save();" input-class="form-control"></datepicker>
                        </div></div>
                      </div>
                      
                      <div v-if="ticket.is_lifecycle_ticket" class="form-group">
                        <div class="za-label">Date Butoir</div>
                        <datepicker :format="format" :language="fr" :clear-button="true" :value="dueDate" @input="dueDate = $event; save();" input-class="form-control" wrapper-class="due-date-picker"></datepicker> 
                        <template v-if="isPassedDueDate && !isClosed">
                          <small class="text-muted">La date est dépassée</small>
                        </template>
                        <template v-if="isSoonDue && !isClosed">
                          <small class="text-muted">Bientôt à échéance</small>
                        </template>
                      </div>

                      <div class="form-group">
                        <strong class="control-label">Description</strong>
                        <br>
                        <div class="za_editbox" v-show="readmode.description" v-on:click="editMode('description')">
                          <em v-if="!ticket.description" class="text-muted">Entrer une description...</em>
                          <div v-html="ticket.description"></div>
                        </div>
                        <span v-show="!readmode.description">
                          <trumbowyg :config="$trumbowygConfig" style="height:100px" class="form-control" v-model="ticket.description"></trumbowyg>
                          <label class="error" v-if="errors.description">{{ errors.description }}</label>
                          <div style="margin-top:5px">
                            <button type="button" class="btn btn-primary btn-sm" v-on:click="save()"><i class="fas fa-save" aria-hidden="true"></i> Enregistrer</button>
                            <button type="button" class="btn btn-link btn-sm" v-on:click="cancelEditMode('description')">Annuler</button>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <ListDocuments v-if="ticket && ticket.service_provider_id" :parent-id="$route.params.ticket_id" parent-type="ticket" :service-provider-id="ticket.service_provider_id"></ListDocuments>
                  
                  <hr style="color:#d0d0d0;width:100%;height:0;border:0.5px solid">
                  <ListComment :parent_id="$route.params.ticket_id" parent_class="ticket"></ListComment>

                </div>
                <div class="col-sm-3">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <strong class="control-label">Statut </strong>
                      <select v-model="status" class="form-control" v-on:input="saveStatus($event)">
                        <option v-for="option in status_option" v-bind:value="option.status_id" v-bind:key="option.status_id">
                          {{ option.status_name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  
                  <div v-if="ticket.is_lifecycle_ticket" class="col-sm-12" style="margin-top:15px">
                    <div class="form-group">
                      <strong class="control-label">Priorité</strong>
                      <priority-pulldown v-model="ticket.priority" v-on:input="savePriority()"></priority-pulldown>
                    </div>
                  </div>

                  <div class="col-sm-12" style="margin-top:15px">
                    <div class="form-group">
                      <strong class="control-label">Créateur </strong><br>
                      {{ticket.created_by}}
                    </div>
                  </div>

                  <div class="col-sm-12" style="margin-top:15px">
                    <div class="form-group">
                      <strong class="control-label">Responsable</strong><br>
                      <select v-model="responsable" class="form-control" v-on:input="saveAssignee($event)">
                        <option value="0">Non assigné</option>
                        <option v-for="option in responsable_option"
                          :value="option.user_id" :key="option.user_id">
                          {{ option.responsable_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-12" style="margin-top:15px">
                    <span class="form-group text-muted">
                      <small :title="ticket.created_at">Création : {{moment(ticket.created_at).fromNow()}}</small>
                    </span>
                    <span v-if="showModifiedDate" class="form-group text-muted">
                      <small :title="ticket.modified_at">Dernière mise-à-jour : {{moment(ticket.modified_at).fromNow()}}</small>
                    </span>
                    <span v-if="showClosedDate" class="form-group text-muted">
                      <small :title="ticket.closed_at">Fermeture : {{moment(ticket.closed_at).fromNow()}}</small>
                    </span>
                  </div>
                  <div class="col-sm-12" v-show="showsuperadmin"><br>
                    <button class="btn btn-primary" v-on:click="show_confirm=true" ><i class="fas fa-trash-alt"></i> Supprimer le billet</button>
                  </div>
                </div>
              </div>
            </div>
            <footer class="panel-footer">
              <div class="row">
                <div class="col-sm-12">
                  <button class="btn btn-default" v-on:click="back" >Retour</button>
                </div>
              </div>
            </footer>
          </section>
        </div>
      </div>
      <div class="modal-mask" v-show="show_confirm">
        <div class="modal-block modal-block">
          <section class="panel">
            <header class="panel-heading">
                <strong>Êtes-vous certain?</strong>
            </header>
            <div class="panel-body">
              <div class="modal-wrapper">
                <div class="modal-text">
                  <p>Êtes-vous certain de vouloir supprimer ce billet?</p>
                </div>
              </div>
            </div>
            <footer class="panel-footer">
              <div class="row">
                <div class="col-md-12 text-right">
                  <a class="btn btn-default" v-on:click="show_confirm=false">Non</a>&nbsp;&nbsp;<a class="btn btn-default" v-on:click="deleteTicket()">Oui</a>
                </div>
              </div>
            </footer>
          </section>
        </div>
    </div>
    </main>

</template>

<style>
.ticket_type {
  color: #808080;
  font-size: 1.3em;
}
.vdp-datepicker__clear-button {
  position: absolute;
  right: 0.8em;
  top: 50%;
  transform: translateY(-50%);
}
.due-date-picker {
  display: inline-block;
  width: 10em;
  margin-right: 1em;
}
</style>

<script>

import axios from 'axios';
import ListComment from '@/components/ListComment.vue';
import ListDocuments from '@/components/ListDocuments.vue'
import Datepicker from 'vuejs-datepicker'
import PriorityPulldown from '../components/PriorityPulldown.vue'
import {en, fr} from 'vuejs-datepicker/dist/locale'
import Vue from 'vue';

export default {
  data: function() {return {
    show_confirm:false,
    showsuperadmin:false,
    readmode: {title:true, description:true},
    keyword:'',
    ticket_id:'',
    default_priority: 2,
    ticket: {
      modified_at:'',
      effective_at:'',
      service_provider: '',
      service_provider_id: null,
      requirement_id: null,
      requirement_master_num: '',
      requirement_master_name: '',
      designation_dossier_id: null,
      designation_dossier_name: ''
    },
    field_backup: null,
    errors: {title: '',description:''},
    status:'',
    responsable:'',
    orig_responsable:'',
    orig_priority:null,
    status_option: {},
    responsable_option: {},
    showedit:false,
    enableSave: false,
    format:'yyyy-MM-dd',
    en: en,
    fr: fr,
  }},

  name: 'TicketView',
  components: {
    ListComment,
    ListDocuments,
    Datepicker,
    PriorityPulldown
  },
  computed: {
    showModifiedDate() {
      return this.ticket.modified_at && this.ticket.modified_at!="0000-00-00 00:00:00"
    },
    showClosedDate() {
      return this.isClosed
    },
    dueDate: {
      get() {
        if (!this.ticket || !this.ticket.due_date) { return }
        return this.parseDate(this.ticket.due_date)
      },
      set(newVal) {
        this.ticket.due_date = this.fixDate(newVal)
      }
    },
    effectiveAt: {
      get() {
        if (!this.ticket || !this.ticket.effective_at) { return }
        return this.parseDate(this.ticket.effective_at)
      },
      set(newVal) {
        this.ticket.effective_at = this.fixDate(newVal)
      }
    },
    isPassedDueDate() {
      return this.moment.utc(this.ticket.due_date).isBefore(this.moment().subtract(1, 'days'))
    },
    isSoonDue() {
      return !this.isPassedDueDate && this.moment.utc(this.ticket.due_date).isBefore(this.moment().add(5, 'days'))
    },
    isClosed() {
      return this.ticket.closed_at && this.ticket.closed_at!="0000-00-00 00:00:00"
    }
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/ticket.php',
          { params: {ticket_id: this.$route.params.ticket_id}})
        .then(response => {
          this.$checkApiErrors(response.data);
          this.ticket = response.data.ticket;
          this.ticket_id=this.$route.params.ticket_id;
          this.showsuperadmin=this.ticket.showsuperadmin;
          this.status_option=response.data.ticket_status;
          this.status=this.ticket.status;
          this.responsable=this.ticket.responsable_id;
          this.orig_responsable=this.ticket.responsable_id;
          this.responsable_option=response.data.responsable;
          this.showedit=this.ticket.showedit;
          this.enableSave = true;

          if (this.ticket.is_lifecycle_ticket) {
            if (this.ticket.priority === null) {
              this.ticket.priority = this.default_priority
            }

            this.orig_priority=this.ticket.priority
          }
        })
    },
    save: function()
    {
      let data = {
        ticket_id:this.ticket_id,
        ticket_status:this.status,
        responsable:this.responsable,
        title:this.ticket.title,
        effective_at:this.ticket.effective_at,
        description:this.ticket.description
      }

      if (this.ticket.is_lifecycle_ticket) {
        data['due_date'] = this.ticket.due_date
        data['priority'] = this.ticket.priority
      }

      axios
        .post(this.$root.$data.server_base + '/api/ticket_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
        .then((response) => {
          this.$checkApiErrors(response.data);
          this.readmode.title=true;
          this.readmode.description=true;
          this.refresh();
        })
    },
    saveStatus: function(event)
    {
      const newVal = event.target.value

      let data = {
        ticket_id:this.ticket_id,
        ticket_status: newVal,
      }

      axios
        .post(this.$root.$data.server_base + '/api/ticket_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
        .then((response) => {
          this.$checkApiErrors(response.data);
          this.ticket.modified_at = response.data.modified_at;
          this.ticket.closed_at = response.data.closed_at;
        })
    },

    saveAssignee: function(event)
    {
      const newVal = event.target.value

      if(newVal==this.orig_responsable) return;
    
      let data = {
        ticket_id:this.ticket_id,
        responsable: newVal
      }

      axios
        .post(this.$root.$data.server_base + '/api/ticket_save.php',
            data,
            {headers:{
                'Content-Type': 'application/json',
          }})
        .then((response) => {
          this.$checkApiErrors(response.data);
          this.ticket.modified_at = response.data.modified_at;
        })
    },

    savePriority: function()
    {
      Vue.nextTick(() => {
        if(this.ticket.priority===this.orig_priority) return;

        let data = {
          ticket_id:this.ticket_id,
          priority:this.ticket.priority
        }

        axios
          .post(this.$root.$data.server_base + '/api/ticket_save.php',
              data,
              {headers:{
                  'Content-Type': 'application/json',
            }})
          .then((response) => {
            this.$checkApiErrors(response.data);
            this.ticket.modified_at = response.data.modified_at;
          })
      })
    },

    deleteTicket: function()
    {
      axios
        .get(this.$root.$data.server_base + '/api/ticket_delete.php',
          { params:{ticket_id:this.ticket_id}})
        .then((response) => {
          if(!this.$checkApiErrors(response.data))
            this.$router.go(-1);
          this.show_confirm = false;
        })
    },

    back: function()
    {
      this.$router.go(-1);//this.$router.push({ name: 'liste_billets'});
    },
    editMode: function(field)
    {
      for (let [key, value] of Object.entries(this.readmode)) {
        if(key != field && value==false) {
          // Warn only if value changed
          if(this.ticket[key]!=this.field_backup) {
            this.errors[key]="Sauvegardez ou annulez les changements avant de passer à un autre champ";
            return;
          }
          else {
            this.cancelEditMode(key);
          }
        }
      }
      this.readmode[field] = false;
      this.field_backup = this.ticket[field];
    },
    cancelEditMode: function(field)
    {
      this.readmode[field] = true;
      this.ticket[field] = this.field_backup;
      this.errors[field] = "";
    },
    fixDate(event) {
      if (event === null) { return null }
      return this.moment(event).format('YYYY-MM-DD');
    },
    parseDate(dateStr) {
      const [year, month, date] = dateStr.substring(0, 10).split('-')
      if (year === undefined || month === undefined || date === undefined ) { return null }
      if (Number(year) === 0 || Number(month) === 0 || Number(date) === 0 ) { return null }
      return new Date(year, month - 1, date)
    }

  },
  

  mounted () {
    this.refresh();
  }
}
</script>
